import {
  Kaaba1Icon,
  KaabaSelectedIcon,
  Mosque2Icon,
  MosqueMadinaSelectedIcon,
  UserSearch1Icon,
  UserSerachSelectedIcon,
  UserUnlockSelectedIcon,
  UserUnlock01Icon,
} from "@/assets/icons";

export const DATE_FORMAT = "DD MMMM YYYY";
export const TIME_FORMAT = "HH:mm";
export const TIME_FORMAT_12_HOURS = "hh:mm a";
export const DATE_TIME_FORMAT = "HH:mm - DD MMMM YYYY";
export const DATE_TIME_FULL_FORMAT = "HH:mm:ss - DD MMMM YYYY";
export const DATE_TIME_FORMAT_12_HOURS = "hh:mm a - DD MMMM YYYY";

export const DATE_TIME_FORMAT_INPUT = "YYYY-MM-DD HH:mm";

export const SYSTEMS = {
  makkah: "makkah",
  madina: "madina",
  user_management: "user_management",
  seasonal_hr: "seasonal_hr",
};

export const EXAMINATION_TYPES = {
  normal: "normal",
  track: "track",
  complaint: "complaint",
};

export const ORDER_STATUS = {
  not_created: "not_created",
  in_progress: "in_progress",
  completed: "completed",
  cancelled: "cancelled",
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  expired: "expired",
};

export const EXAMINATION_RESULT_STATUS = {
  qualified: "qualified",
  not_qualified: "not_qualified",
};

export const PLATFORMS = {
  makkah: {
    icon: <Kaaba1Icon />,
    selectedIcon: <KaabaSelectedIcon />,
    name: "DROPDOWN_MAKKAH_PLATFORM",
    path: "/app/makkah",
    system_id: 1,
    key: "makkah",
  },

  madina: {
    icon: <Mosque2Icon />,
    selectedIcon: <MosqueMadinaSelectedIcon />,
    name: "DROPDOWN_MADINAH_PLATFORM",
    path: "/app/madina",
    system_id: 2,
    key: "madina",
  },

  seasonal_hr: {
    icon: <UserSearch1Icon />,
    selectedIcon: <UserSerachSelectedIcon />,
    name: "DROPDOWN_SEASONAL_RECRUITMENT_PLATFORM",
    path: "/app/seasonal_hr",
    system_id: 3,
    key: "seasonal_hr",
  },

  user_management: {
    icon: <UserUnlock01Icon />,
    selectedIcon: <UserUnlockSelectedIcon />,
    name: "DROPDOWN_USERS_MANAGEMENT_PLATFORM",
    path: "/app/user_management/users",
    system_id: 4,
    key: "user_management",
  },
};

export const CITIES = {
  makkah: {
    id: 3,
    name: "Makkah",
  },
  madina: {
    id: 4,
    name: "Madina",
  },
};

export const MED_RECEPTION_TABS = {
  today: {
    key: "today",
    label: "TODAY",
  },
  all: {
    key: "all",
    label: "ALL",
  },
};

export const NUSUK_CITY_ID = {
  makkah: 603,
  madina: 605,
};

export const MODES = {
  edit: "edit",
  view: "view",
  create: "create",
}

export const REFRESH_INTERVAL = 1000 * 60 * 10;

export const PILGRIM_STATUS = [
  {
    "key": "not_arrived",
    "label_ar": "غير موجود او لم يصل",
    "label_en": "Not arrived",
    "color": "yellow"
  },
  {
    "key": "exist",
    "label_ar": "موجود",
    "label_en": "Exist",
    "color": "green"
  },
  {
    "key": "departed",
    "label_ar": "مغادر",
    "label_en": "Departed",
    "color": "red"
  },
  {
    "key": "deceased",
    "label_ar": "متوفي",
    "label_en": "Deceased",
    "color": "black"
  }
]

const pdfMimeType = "application/pdf"
const excelMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

export const MIME_TYPES = {
  pdf: pdfMimeType,
  excel: excelMimeType,
  json: "application/json",
}

export const ROLES = {
  super_admin: "super_admin",
}

export const permissions = {
  view_pilgrim_report_accommodated_makkah: "view_pilgrim_report_accommodated_makkah",
  view_pilgrim_report_accommodated_madina: "view_pilgrim_report_accommodated_madina",
  list_users_for_makkah: "list_users_for_makkah",
  create_user_for_makkah: "create_user_for_makkah",
  update_user_for_makkah: "update_user_for_makkah",
  delete_user_for_makkah: "delete_user_for_makkah",
  reset_user_password_for_makkah: "reset_user_password_for_makkah",
  update_user_status_for_makkah: "update_user_status_for_makkah",
  upload_user_profile_image_for_makkah: "upload_user_profile_image_for_makkah",
  assign_user_permissions_for_makkah: "assign_user_permissions_for_makkah",
  assign_user_groups_for_makkah: "assign_user_groups_for_makkah",
  list_groups_for_makkah: "list_groups_for_makkah",
  create_group_for_makkah: "create_group_for_makkah",
  update_group_for_makkah: "update_group_for_makkah",
  delete_group_for_makkah: "delete_group_for_makkah",
  assign_group_for_makkah: "assign_group_for_makkah",
  assign_group_permissions_for_makkah: "assign_group_permissions_for_makkah",
  list_permissions_for_makkah: "list_permissions_for_makkah",
  create_permission_for_makkah: "create_permission_for_makkah",
  update_permission_for_makkah: "update_permission_for_makkah",
  delete_permission_for_makkah: "delete_permission_for_makkah",
  assign_permission_for_makkah: "assign_permission_for_makkah",
  assign_system_for_makkah: "assign_system_for_makkah",
  list_systems_for_makkah: "list_systems_for_makkah",
  assign_role_for_makkah: "assign_role_for_makkah",
  list_users_for_madinah: "list_users_for_madinah",
  create_user_for_madinah: "create_user_for_madinah",
  update_user_for_madinah: "update_user_for_madinah",
  delete_user_for_madinah: "delete_user_for_madinah",
  reset_user_password_for_madinah: "reset_user_password_for_madinah",
  update_user_status_for_madinah: "update_user_status_for_madinah",
  upload_user_profile_image_for_madinah: "upload_user_profile_image_for_madinah",
  assign_user_permissions_for_madinah: "assign_user_permissions_for_madinah",
  assign_user_groups_for_madinah: "assign_user_groups_for_madinah",
  list_groups_for_madinah: "list_groups_for_madinah",
  create_group_for_madinah: "create_group_for_madinah",
  update_group_for_madinah: "update_group_for_madinah",
  delete_group_for_madinah: "delete_group_for_madinah",
  assign_group_for_madinah: "assign_group_for_madinah",
  assign_group_permissions_for_madinah: "assign_group_permissions_for_madinah",
  list_permissions_for_madinah: "list_permissions_for_madinah",
  create_permission_for_madinah: "create_permission_for_madinah",
  update_permission_for_madinah: "update_permission_for_madinah",
  delete_permission_for_madinah: "delete_permission_for_madinah",
  assign_permission_for_madinah: "assign_permission_for_madinah",
  assign_system_for_madinah: "assign_system_for_madinah",
  list_systems_for_madinah: "list_systems_for_madinah",
  assign_role_for_madinah: "assign_role_for_madinah",
  list_port_reception_cards_from_nusk_for_madina_for_madinah: "list_port_reception_cards_from_nusk_for_madina_for_madinah",
  manage_port_reception_cards_from_nusk_for_madina_for_madinah: "manage_port_reception_cards_from_nusk_for_madina_for_madinah",
  list_madina_arrival_bags_for_madinah: "list_madina_arrival_bags_for_madinah",
  manage_madina_arrival_bags_for_madinah: "manage_madina_arrival_bags_for_madinah",
  create_madina_arrival_reports_for_madinah: "create_madina_arrival_reports_for_madinah",
  update_madina_arrival_reports_for_madinah: "update_madina_arrival_reports_for_madinah",
  delete_madina_arrival_reports_for_madinah: "delete_madina_arrival_reports_for_madinah",
  list_users_for_seasonal_hr: "list_users_for_seasonal_hr",
  create_user_for_seasonal_hr: "create_user_for_seasonal_hr",
  update_user_for_seasonal_hr: "update_user_for_seasonal_hr",
  delete_user_for_seasonal_hr: "delete_user_for_seasonal_hr",
  reset_user_password_for_seasonal_hr: "reset_user_password_for_seasonal_hr",
  update_user_status_for_seasonal_hr: "update_user_status_for_seasonal_hr",
  upload_user_profile_image_for_seasonal_hr: "upload_user_profile_image_for_seasonal_hr",
  assign_user_permissions_for_seasonal_hr: "assign_user_permissions_for_seasonal_hr",
  assign_user_groups_for_seasonal_hr: "assign_user_groups_for_seasonal_hr",
  list_groups_for_seasonal_hr: "list_groups_for_seasonal_hr",
  create_group_for_seasonal_hr: "create_group_for_seasonal_hr",
  update_group_for_seasonal_hr: "update_group_for_seasonal_hr",
  delete_group_for_seasonal_hr: "delete_group_for_seasonal_hr",
  assign_group_for_seasonal_hr: "assign_group_for_seasonal_hr",
  assign_group_permissions_for_seasonal_hr: "assign_group_permissions_for_seasonal_hr",
  list_permissions_for_seasonal_hr: "list_permissions_for_seasonal_hr",
  create_permission_for_seasonal_hr: "create_permission_for_seasonal_hr",
  update_permission_for_seasonal_hr: "update_permission_for_seasonal_hr",
  delete_permission_for_seasonal_hr: "delete_permission_for_seasonal_hr",
  assign_permission_for_seasonal_hr: "assign_permission_for_seasonal_hr",
  assign_system_for_seasonal_hr: "assign_system_for_seasonal_hr",
  list_systems_for_seasonal_hr: "list_systems_for_seasonal_hr",
  assign_role_for_seasonal_hr: "assign_role_for_seasonal_hr",
  list_users_for_user_management: "list_users_for_user_management",
  create_user_for_user_management: "create_user_for_user_management",
  update_user_for_user_management: "update_user_for_user_management",
  delete_user_for_user_management: "delete_user_for_user_management",
  reset_user_password_for_user_management: "reset_user_password_for_user_management",
  update_user_status_for_user_management: "update_user_status_for_user_management",
  upload_user_profile_image_for_user_management: "upload_user_profile_image_for_user_management",
  assign_user_permissions_for_user_management: "assign_user_permissions_for_user_management",
  assign_user_groups_for_user_management: "assign_user_groups_for_user_management",
  list_groups_for_user_management: "list_groups_for_user_management",
  create_group_for_user_management: "create_group_for_user_management",
  update_group_for_user_management: "update_group_for_user_management",
  delete_group_for_user_management: "delete_group_for_user_management",
  assign_group_for_user_management: "assign_group_for_user_management",
  assign_group_permissions_for_user_management: "assign_group_permissions_for_user_management",
  list_permissions_for_user_management: "list_permissions_for_user_management",
  create_permission_for_user_management: "create_permission_for_user_management",
  update_permission_for_user_management: "update_permission_for_user_management",
  delete_permission_for_user_management: "delete_permission_for_user_management",
  assign_permission_for_user_management: "assign_permission_for_user_management",
  assign_system_for_user_management: "assign_system_for_user_management",
  list_systems_for_user_management: "list_systems_for_user_management",
  assign_role_for_user_management: "assign_role_for_user_management",
  list_housing: "list_housing",
  view_housing_details: "view_housing_details",
  edit_housing_data: "edit_housing_data",
  evacuate_housing: "evacuate_housing",
  list_housing_contracts: "list_housing_contracts",
  view_housing_contract_details: "view_housing_contract_details",
  list_house_inspection_examinations: "list_house_inspection_examinations",
  list_house_inspection_orders: "list_house_inspection_orders",
  start_house_inspection_order: "start_house_inspection_order",
  create_house_inspection_order: "create_house_inspection_order",
  edit_house_inspection_order: "edit_house_inspection_order",
  delete_house_inspection_order: "delete_house_inspection_order",
  complete_house_inspection_order: "complete_house_inspection_order",
  view_house_inspection_results: "view_house_inspection_results",
  view_house_inspection_requests_reports: "view_house_inspection_requests_reports",
  list_house_inspection_examination_periods: "list_house_inspection_examination_periods",
  create_house_inspection_examination_periods: "create_house_inspection_examination_periods",
  edit_house_inspection_examination_periods: "edit_house_inspection_examination_periods",
  delete_house_inspection_examination_periods: "delete_house_inspection_examination_periods",
  list_house_inspection_groups: "list_house_inspection_groups",
  create_house_inspection_groups: "create_house_inspection_groups",
  edit_house_inspection_groups: "edit_house_inspection_groups",
  delete_house_inspection_groups: "delete_house_inspection_groups",
  list_house_inspection_items: "list_house_inspection_items",
  create_house_inspection_items: "create_house_inspection_items",
  edit_house_inspection_items: "edit_house_inspection_items",
  delete_house_inspection_items: "delete_house_inspection_items",
  list_house_inspection_period_codes: "list_house_inspection_period_codes",
  create_house_inspection_period_codes: "create_house_inspection_period_codes",
  edit_house_inspection_period_codes: "edit_house_inspection_period_codes",
  delete_house_inspection_period_codes: "delete_house_inspection_period_codes",
  manage_house_inspection_period_code_users: "manage_house_inspection_period_code_users",
  view_planning: "view_planning",
  view_organizers: "view_organizers",
  list_basic_packages: "list_basic_packages",
  view_basic_packages: "view_basic_packages",
  view_visas: "view_visas",
  list_pilgrim_visas: "list_pilgrim_visas",
  list_campaigns: "list_campaigns",
  view_campaigns: "view_campaigns",
  create_campaigns: "create_campaigns",
  update_campaigns: "update_campaigns",
  delete_campaigns: "delete_campaigns",
  import_campaigns: "import_campaigns",
  list_campaign_details: "list_campaign_details",
  view_campaign_details: "view_campaign_details",
  create_campaign_details: "create_campaign_details",
  update_campaign_details: "update_campaign_details",
  delete_campaign_details: "delete_campaign_details",
  list_groups: "list_groups",
  view_groups: "view_groups",
  create_groups: "create_groups",
  update_groups: "update_groups",
  delete_groups: "delete_groups",
  list_group_details: "list_group_details",
  view_group_details: "view_group_details",
  create_group_details: "create_group_details",
  update_group_details: "update_group_details",
  delete_group_details: "delete_group_details",
  view_camps: "view_camps",
  view_compliance: "view_compliance",
  list_nusk_service_centers: "list_nusk_service_centers",
  view_dashboard_summary_makkah: "view_dashboard_summary_makkah",
  view_dashboard_sections_makkah: "view_dashboard_sections_makkah",
  view_dashboard_summary_madina: "view_dashboard_summary_madina",
  view_dashboard_sections_madina: "view_dashboard_sections_madina",
  view_dashboard_summary_user_management: "view_dashboard_summary_user_management",
  view_dashboard_summary_hr: "view_dashboard_summary_hr",
  list_port_reception_cards_from_missions: "list_port_reception_cards_from_missions",
  control_port_reception_cards_from_missions: "control_port_reception_cards_from_missions",
  list_port_reception_cards_from_nask: "list_port_reception_cards_from_nask",
  controle_port_reception_cards_from_nusk: "controle_port_reception_cards_from_nusk",
  list_center_reception_cards_from_ports: "list_center_reception_cards_from_ports",
  control_center_reception_cards_from_ports: "control_center_reception_cards_from_ports",
  list_center_reception_cards_between_cities: "list_center_reception_cards_between_cities",
  control_center_reception_cards_between_cities: "control_center_reception_cards_between_cities",
  list_makkah_reception_manifests: "list_makkah_reception_manifests",
  list_makkah_reception_manifest_pilgrims: "list_makkah_reception_manifest_pilgrims",
  list_makkah_reception_tafweejs: "list_makkah_reception_tafweejs",
  list_makkah_reception_tafweej_pilgrims: "list_makkah_reception_tafweej_pilgrims",
  list_pilgrim_data: "list_pilgrim_data",
  control_pilgrim_data: "control_pilgrim_data",
  assign_pilgrim_accommodation: "assign_pilgrim_accommodation",
  cancel_pilgrim_accommodation: "cancel_pilgrim_accommodation",
  view_accommodations: "view_accommodations",
  list_port_reception_cards_from_nusk_for_madina: "list_port_reception_cards_from_nusk_for_madina",
  manage_port_reception_cards_from_nusk_for_madina: "manage_port_reception_cards_from_nusk_for_madina",
  list_arrival_bags_for_madina: "list_arrival_bags_for_madina",
  manage_arrival_bags_for_madina: "manage_arrival_bags_for_madina",
  create_arrival_bags_for_madina: "create_arrival_bags_for_madina",
  update_arrival_bags_for_madina: "update_arrival_bags_for_madina",
  delete_arrival_bags_for_madina: "delete_arrival_bags_for_madina",
  create_arrival_reports_for_madina: "create_arrival_reports_for_madina",
  update_arrival_reports_for_madina: "update_arrival_reports_for_madina",
  delete_arrival_reports_for_madina: "delete_arrival_reports_for_madina",
  list_madina_reception_manifests: "list_madina_reception_manifests",
  view_madina_reception_manifest: "view_madina_reception_manifest",
  update_madina_reception_manifest_bag_number: "update_madina_reception_manifest_bag_number",
  set_madina_reception_manifest_arrive_time: "set_madina_reception_manifest_arrive_time",
  cancel_madina_reception_manifest_arrival: "cancel_madina_reception_manifest_arrival",
  list_madina_reception_manifest_pilgrims: "list_madina_reception_manifest_pilgrims",
  accommodate_madina_reception_manifest_pilgrims: "accommodate_madina_reception_manifest_pilgrims",
  list_madina_reception_manifest_bag_details: "list_madina_reception_manifest_bag_details",
  create_madina_reception_manifest_bag_detail: "create_madina_reception_manifest_bag_detail",
  update_madina_reception_manifest_bag_detail: "update_madina_reception_manifest_bag_detail",
  delete_madina_reception_manifest_bag_detail: "delete_madina_reception_manifest_bag_detail",
  list_madina_reception_tafweejs: "list_madina_reception_tafweejs",
  update_madina_reception_tafweej_bag_number: "update_madina_reception_tafweej_bag_number",
  set_madina_reception_tafweej_arrive_time: "set_madina_reception_tafweej_arrive_time",
  cancel_madina_reception_tafweej_arrival: "cancel_madina_reception_tafweej_arrival",
  list_madina_reception_tafweej_pilgrims: "list_madina_reception_tafweej_pilgrims",
  accommodate_madina_reception_tafweej_pilgrims: "accommodate_madina_reception_tafweej_pilgrims",
  accommodate_madina_custom_reception_pilgrims:
    "accommodate_madina_custom_reception_pilgrims",
  list_madina_custom_reception_bag_pilgrims:
    "list_madina_custom_reception_bag_pilgrims",
  list_madina_reception_tafweej_bag_details: "list_madina_reception_tafweej_bag_details",
  delete_madina_reception_tafweej_bag_detail: "delete_madina_reception_tafweej_bag_detail",
  view_export_housing_contract_detail_report: "view_export_housing_contract_detail_report",
  makkah_view_export_campaign_group_pilgrims: "makkah_view_export_campaign_group_pilgrims",
  view_pilgrim_report_not_coming_makkah: "view_pilgrim_report_not_coming_makkah",
  view_pilgrim_report_not_coming_madina: "view_pilgrim_report_not_coming_madina",
  view_pilgrim_report_not_accommodated_makkah: "view_pilgrim_report_not_accommodated_makkah",
  view_pilgrim_report_not_accommodated_madina: "view_pilgrim_report_not_accommodated_madina",
  list_campaigns_for_madina: "list_campaigns_for_madina",
  view_campaigns_for_madina: "view_campaigns_for_madina",
  create_campaigns_for_madina: "create_campaigns_for_madina",
  update_campaigns_for_madina: "update_campaigns_for_madina",
  delete_campaigns_for_madina: "delete_campaigns_for_madina",
  list_campaign_details_for_madina: "list_campaign_details_for_madina",
  view_campaign_details_for_madina: "view_campaign_details_for_madina",
  create_campaign_details_for_madina: "create_campaign_details_for_madina",
  update_campaign_details_for_madina: "update_campaign_details_for_madina",
  delete_campaign_details_for_madina: "delete_campaign_details_for_madina",
  list_groups_for_madina: "list_groups_for_madina",
  view_groups_for_madina: "view_groups_for_madina",
  create_groups_for_madina: "create_groups_for_madina",
  update_groups_for_madina: "update_groups_for_madina",
  delete_groups_for_madina: "delete_groups_for_madina",
  list_group_details_for_madina: "list_group_details_for_madina",
  view_group_details_for_madina: "view_group_details_for_madina",
  create_group_details_for_madina: "create_group_details_for_madina",
  update_group_details_for_madina: "update_group_details_for_madina",
  delete_group_details_for_madina: "delete_group_details_for_madina",
  assign_pilgrim_accommodation_for_madina: "assign_pilgrim_accommodation_for_madina",
  cancel_pilgrim_accommodation_for_madina: "cancel_pilgrim_accommodation_for_madina",
  view_accommodations_for_madina: "view_accommodations_for_madina",
  list_makkah_incident_reports: "list_makkah_incident_reports",
  create_makkah_incident_reports: "create_makkah_incident_reports",
  update_makkah_incident_reports: "update_makkah_incident_reports",
  delete_makkah_incident_reports: "delete_makkah_incident_reports",
  view_makkah_incident_reports_details: "view_makkah_incident_reports_details",
  search_pilgrims_for_makkah_incident_reports: "search_pilgrims_for_makkah_incident_reports",
  makkah_view_export_incident_reports: "makkah_view_export_incident_reports",
  view_export_makkah_arrival_campaign_segments_report: "view_export_makkah_arrival_campaign_segments_report",
  view_export_makkah_group_details_report: "view_export_makkah_group_details_report",
  list_madina_incident_reports: "list_madina_incident_reports",
  create_madina_incident_reports: "create_madina_incident_reports",
  update_madina_incident_reports: "update_madina_incident_reports",
  delete_madina_incident_reports: "delete_madina_incident_reports",
  view_madina_incident_reports_details: "view_madina_incident_reports_details",
  search_pilgrims_for_madina_incident_reports: "search_pilgrims_for_madina_incident_reports",
  madina_view_export_incident_reports: "madina_view_export_incident_reports",
  view_export_house_contract_campaigns_report: "view_export_house_contract_campaigns_report",
  list_departure_campaigns: "list_departure_campaigns",
  view_departure_campaigns: "view_departure_campaigns",
  create_departure_campaigns: "create_departure_campaigns",
  update_departure_campaigns: "update_departure_campaigns",
  delete_departure_campaigns: "delete_departure_campaigns",
  import_departure_campaigns: "import_departure_campaigns",
  list_departure_campaign_details: "list_departure_campaign_details",
  view_departure_campaign_details: "view_departure_campaign_details",
  create_departure_campaign_details: "create_departure_campaign_details",
  update_departure_campaign_details: "update_departure_campaign_details",
  delete_departure_campaign_details: "delete_departure_campaign_details",
  view_departure_campaigns_details: "view_departure_campaigns_details",
  create_departure_campaigns_details: "create_departure_campaigns_details",
  update_departure_campaigns_details: "update_departure_campaigns_details",
  delete_departure_campaigns_details: "delete_departure_campaigns_details",
  import_departure_campaigns_details: "import_departure_campaigns_details",
  preview_departure_campaigns_details: "preview_departure_campaigns_details",
  list_departure_groups: "list_departure_groups",
  view_departure_groups: "view_departure_groups",
  create_departure_groups: "create_departure_groups",
  update_departure_groups: "update_departure_groups",
  delete_departure_groups: "delete_departure_groups",
  list_departure_group_details: "list_departure_group_details",
  view_departure_group_details: "view_departure_group_details",
  create_departure_group_details: "create_departure_group_details",
  update_departure_group_details: "update_departure_group_details",
  delete_departure_group_details: "delete_departure_group_details",
  list_makkah_group_pilgrims_inquiry: "list_makkah_group_pilgrims_inquiry",
  view_export_food_contracts_report: "view_export_food_contracts_report",
  list_departure_campaigns_for_madina: "list_departure_campaigns_for_madina",
  view_departure_campaigns_for_madina: "view_departure_campaigns_for_madina",
  list_departure_campaign_details_for_madina: "list_departure_campaign_details_for_madina",
  view_departure_campaign_details_for_madina: "view_departure_campaign_details_for_madina",
  create_departure_campaign_details_for_madina: "create_departure_campaign_details_for_madina",
  update_departure_campaign_details_for_madina: "update_departure_campaign_details_for_madina",
  delete_departure_campaign_details_for_madina: "delete_departure_campaign_details_for_madina",
  view_departure_campaigns_details_for_madina: "view_departure_campaigns_details_for_madina",
  create_departure_campaigns_details_for_madina: "create_departure_campaigns_details_for_madina",
  update_departure_campaigns_details_for_madina: "update_departure_campaigns_details_for_madina",
  delete_departure_campaigns_details_for_madina: "delete_departure_campaigns_details_for_madina",
  import_departure_campaigns_details_for_madina: "import_departure_campaigns_details_for_madina",
  preview_departure_campaigns_details_for_madina: "preview_departure_campaigns_details_for_madina",
  list_departure_groups_for_madina: "list_departure_groups_for_madina",
  view_departure_groups_for_madina: "view_departure_groups_for_madina",
  list_departure_group_details_for_madina: "list_departure_group_details_for_madina",
  view_departure_group_details_for_madina: "view_departure_group_details_for_madina",
  create_departure_group_details_for_madina: "create_departure_group_details_for_madina",
  update_departure_group_details_for_madina: "update_departure_group_details_for_madina",
  delete_departure_group_details_for_madina: "delete_departure_group_details_for_madina",
  view_export_housing_contract_detail_report_for_madina: "view_export_housing_contract_detail_report_for_madina",
  view_export_food_contracts_report_for_madina: "view_export_food_contracts_report_for_madina",
  view_export_house_contract_campaigns_report_for_madina: "view_export_house_contract_campaigns_report_for_madina",
  list_house_inspection_items_for_madina: "list_house_inspection_items_for_madina",
  create_house_inspection_items_for_madina: "create_house_inspection_items_for_madina",
  edit_house_inspection_items_for_madina: "edit_house_inspection_items_for_madina",
  delete_house_inspection_items_for_madina: "delete_house_inspection_items_for_madina",
  list_house_inspection_examinations_for_madina: "list_house_inspection_examinations_for_madina",
  list_house_inspection_orders_for_madina: "list_house_inspection_orders_for_madina",
  manage_house_inspection_period_code_users_for_madina: "manage_house_inspection_period_code_users_for_madina",
  create_house_inspection_order_for_madina: "create_house_inspection_order_for_madina",
  edit_house_inspection_order_for_madina: "edit_house_inspection_order_for_madina",
  start_house_inspection_order_for_madina: "start_house_inspection_order_for_madina",
  delete_house_inspection_order_for_madina: "delete_house_inspection_order_for_madina",
  complete_house_inspection_order_for_madina: "complete_house_inspection_order_for_madina",
  view_departure_groups_details_for_madina: "view_departure_groups_details_for_madina",
  create_departure_groups_details_for_madina: "create_departure_groups_details_for_madina",
  update_departure_groups_details_for_madina: "update_departure_groups_details_for_madina",
  delete_departure_groups_details_for_madina: "delete_departure_groups_details_for_madina",
  import_departure_groups_details_for_madina: "import_departure_groups_details_for_madina",
  preview_departure_groups_details_for_madina: "preview_departure_groups_details_for_madina",
  set_departure_time_for_madina: "set_departure_time_for_madina",
  remove_departure_time_for_madina: "remove_departure_time_for_madina",
  update_departure_status_for_madina: "update_departure_status_for_madina",
  list_housing_for_madina: "list_housing_for_madina",
  view_housing_details_for_madina: "view_housing_details_for_madina",
  edit_housing_data_for_madina: "edit_housing_data_for_madina",
  evacuate_housing_for_madina: "evacuate_housing_for_madina",
  list_housing_contracts_for_madina: "list_housing_contracts_for_madina",
  view_housing_contract_details_for_madina: "view_housing_contract_details_for_madina",
  view_export_housing_building_delegate_detail_report: "view_export_housing_building_delegate_detail_report",
  view_export_housing_building_delegate_detail_report_for_madina: "view_export_housing_building_delegate_detail_report_for_madina",
  view_export_housing_comprehensive_detail_report: "view_export_housing_comprehensive_detail_report",
  view_export_housing_comprehensive_detail_report_for_madina: "view_export_housing_comprehensive_detail_report_for_madina",
  list_nusuk_cards_batchs: "list_nusuk_cards_batchs",
  view_nusuk_cards_batchs: "view_nusuk_cards_batchs",
  create_nusuk_cards_batchs: "create_nusuk_cards_batchs",
  update_nusuk_cards_batchs: "update_nusuk_cards_batchs",
  delete_nusuk_cards_batchs: "delete_nusuk_cards_batchs",
  change_delivery_status_nusuk_cards_batchs: "change_delivery_status_nusuk_cards_batchs",
  list_nusuk_cards_batch_returns: "list_nusuk_cards_batch_returns",
  create_nusuk_cards_batch_returns: "create_nusuk_cards_batch_returns",
  update_nusuk_cards_batch_returns: "update_nusuk_cards_batch_returns",
  delete_nusuk_cards_batch_returns: "delete_nusuk_cards_batch_returns",
  view_export_nusuk_cards_batch_report: "view_export_nusuk_cards_batch_report",
  list_nusuk_cards_batchs_madina: "list_nusuk_cards_batchs_madina",
  view_nusuk_cards_batchs_madina: "view_nusuk_cards_batchs_madina",
  create_nusuk_cards_batchs_madina: "create_nusuk_cards_batchs_madina",
  update_nusuk_cards_batchs_madina: "update_nusuk_cards_batchs_madina",
  delete_nusuk_cards_batchs_madina: "delete_nusuk_cards_batchs_madina",
  change_delivery_status_nusuk_cards_batchs_madina: "change_delivery_status_nusuk_cards_batchs_madina",
  list_nusuk_cards_batch_returns_madina: "list_nusuk_cards_batch_returns_madina",
  create_nusuk_cards_batch_returns_madina: "create_nusuk_cards_batch_returns_madina",
  update_nusuk_cards_batch_returns_madina: "update_nusuk_cards_batch_returns_madina",
  delete_nusuk_cards_batch_returns_madina: "delete_nusuk_cards_batch_returns_madina",
  view_export_nusuk_cards_batch_report_madina: "view_export_nusuk_cards_batch_report_madina",
  view_pilgrim_report_nationality_stats_makkah: "view_pilgrim_report_nationality_stats_makkah",
  view_pilgrim_report_mission_stats_makkah: "view_pilgrim_report_mission_stats_makkah",
  list_nusuk_cards_batchs_incident_reports: "list_nusuk_cards_batchs_incident_reports",
  list_nusuk_cards_batchs_incident_reports_madina: "list_nusuk_cards_batchs_incident_reports_madina",
  resolve_nusuk_cards_batchs_incident_reports: "resolve_nusuk_cards_batchs_incident_reports",
  list_house_inspection_examination_periods_for_madina: "list_house_inspection_examination_periods_for_madina",
  create_house_inspection_examination_periods_for_madina: "create_house_inspection_examination_periods_for_madina",
  edit_house_inspection_examination_periods_for_madina: "edit_house_inspection_examination_periods_for_madina",
  delete_house_inspection_examination_periods_for_madina: "delete_house_inspection_examination_periods_for_madina",
  list_house_inspection_period_codes_for_madina: "list_house_inspection_period_codes_for_madina",
  create_house_inspection_period_codes_for_madina: "create_house_inspection_period_codes_for_madina",
  edit_house_inspection_period_codes_for_madina: "edit_house_inspection_period_codes_for_madina",
  delete_house_inspection_period_codes_for_madina: "delete_house_inspection_period_codes_for_madina",
  resolve_nusuk_cards_batchs_incident_reports_madina: "resolve_nusuk_cards_batchs_incident_reports_madina",
  list_pilgrim_data_for_madina: "list_pilgrim_data_for_madina",
  control_pilgrim_data_for_madina: "control_pilgrim_data_for_madina",
  list_makkah_group_pilgrims_inquiry_for_madina: "list_makkah_group_pilgrims_inquiry_for_madina",
  list_flight_details: "list_flight_details",
  create_flight_details: "create_flight_details",
  view_flight_details: "view_flight_details",
  update_flight_details: "update_flight_details",
  delete_flight_details: "delete_flight_details",
  list_flight_details_for_madina: "list_flight_details_for_madina",
  create_flight_details_for_madina: "create_flight_details_for_madina",
  view_flight_details_for_madina: "view_flight_details_for_madina",
  update_flight_details_for_madina: "update_flight_details_for_madina",
  delete_flight_details_for_madina: "delete_flight_details_for_madina",
  list_transport_contracts: "list_transport_contracts",
  list_transport_contracts_for_madina: "list_transport_contracts_for_madina",
  list_initial_departure: "list_initial_departure",
  view_initial_departure: "view_initial_departure",
  create_initial_departure: "create_initial_departure",
  assign_initial_departure_pilgrims: "assign_initial_departure_pilgrims",
  remove_initial_departure_pilgrim: "remove_initial_departure_pilgrim",
  delete_initial_departure: "delete_initial_departure",
  list_initial_departure_for_madina: "list_initial_departure_for_madina",
  view_initial_departure_for_madina: "view_initial_departure_for_madina",
  create_initial_departure_for_madina: "create_initial_departure_for_madina",
  assign_initial_departure_pilgrims_for_madina: "assign_initial_departure_pilgrims_for_madina",
  remove_initial_departure_pilgrim_for_madina: "remove_initial_departure_pilgrim_for_madina",
  delete_initial_departure_for_madina: "delete_initial_departure_for_madina",
  list_departure_campaigns_index: "list_departure_campaigns_index",
  list_departure_campaigns_index_for_madina: "list_departure_campaigns_index_for_madina",
  list_departure_groups_index: "list_departure_groups_index",
  list_departure_groups_index_for_madina: "list_departure_groups_index_for_madina",
  view_export_madina_arrival_campaign_segments_report: "view_export_madina_arrival_campaign_segments_report",
  view_export_madina_group_details_report: "view_export_madina_group_details_report",
  view_export_makkah_housed_arrivals_service_center_distribution_report: "view_export_makkah_housed_arrivals_service_center_distribution_report",
  view_export_madina_housed_arrivals_service_center_distribution_report: "view_export_madina_housed_arrivals_service_center_distribution_report",
  view_export_makkah_campaign_statement_report: "view_export_makkah_campaign_statement_report",
  view_export_madina_campaign_statement_report: "view_export_madina_campaign_statement_report",
  view_export_makkah_group_statement_report: "view_export_makkah_group_statement_report",
  view_export_madina_group_statement_report: "view_export_madina_group_statement_report",
  bypass_service_center_listing_scope: "bypass_service_center_listing_scope",
  bypass_service_center_listing_scope_for_madina: "bypass_service_center_listing_scope_for_madina",
  view_house_inspection_results_for_madina: "view_house_inspection_results_for_madina",
  view_house_inspection_requests_reports_for_madina: "view_house_inspection_requests_reports_for_madina",
  makkah_print_passport_receipt: "makkah_print_passport_receipt",
  madina_print_passport_receipt: "madina_print_passport_receipt",
  madina_view_export_campaign_group_pilgrims: "madina_view_export_campaign_group_pilgrims",
  makkah_create_passport_receipt: "makkah_create_passport_receipt",
  madina_create_passport_receipt: "madina_create_passport_receipt",
  view_dashboard_pilgrim_counts_makkah: "view_dashboard_pilgrim_counts_makkah",
  view_dashboard_visas_by_nationality_makkah: "view_dashboard_visas_by_nationality_makkah",
  view_dashboard_arrivals_makkah_by_nationality_makkah: "view_dashboard_arrivals_makkah_by_nationality_makkah",
  view_dashboard_arrivals_madina_by_nationality_makkah: "view_dashboard_arrivals_madina_by_nationality_makkah",
  view_dashboard_incidents_latest_makkah: "view_dashboard_incidents_latest_makkah",
  view_dashboard_house_examinations_summary_makkah: "view_dashboard_house_examinations_summary_makkah",
  view_dashboard_pilgrim_counts_madina: "view_dashboard_pilgrim_counts_madina",
  view_dashboard_visas_by_nationality_madina: "view_dashboard_visas_by_nationality_madina",
  view_dashboard_arrivals_makkah_by_nationality_madina: "view_dashboard_arrivals_makkah_by_nationality_madina",
  view_dashboard_arrivals_madina_by_nationality_madina: "view_dashboard_arrivals_madina_by_nationality_madina",
  view_dashboard_incidents_latest_madina: "view_dashboard_incidents_latest_madina",
  view_dashboard_house_examinations_summary_madina: "view_dashboard_house_examinations_summary_madina",
  view_dashboard_departured_makkah_by_nationality_makkah: "view_dashboard_departured_makkah_by_nationality_makkah",
  view_dashboard_departured_madina_by_nationality_makkah: "view_dashboard_departured_madina_by_nationality_makkah",
  view_dashboard_departured_makkah_by_nationality_madina: "view_dashboard_departured_makkah_by_nationality_madina",
  view_dashboard_departured_madina_by_nationality_madina: "view_dashboard_departured_madina_by_nationality_madina",
  view_dashboard_arrivals_makkah_region_by_day_makkah: "view_dashboard_arrivals_makkah_region_by_day_makkah",
  view_dashboard_arrivals_madina_port_by_day_makkah: "view_dashboard_arrivals_madina_port_by_day_makkah",
  view_dashboard_arrivals_makkah_region_by_day_madina: "view_dashboard_arrivals_makkah_region_by_day_madina",
  view_dashboard_arrivals_madina_port_by_day_madina: "view_dashboard_arrivals_madina_port_by_day_madina",
  view_pilgrim_report_accommodated_nationality_stats_makkah: "view_pilgrim_report_accommodated_nationality_stats_makkah",
  view_pilgrim_report_accommodated_mission_stats_makkah: "view_pilgrim_report_accommodated_mission_stats_makkah",
  view_pilgrim_report_accommodated_nationality_stats_madina: "view_pilgrim_report_accommodated_nationality_stats_madina",
  view_pilgrim_report_accommodated_mission_stats_madina: "view_pilgrim_report_accommodated_mission_stats_madina",
  list_house_inspection_track_cards: "list_house_inspection_track_cards",
  create_house_inspection_track_order: "create_house_inspection_track_order",
  list_house_inspection_track_cards_for_madina: "list_house_inspection_track_cards_for_madina",
  create_house_inspection_track_order_for_madina: "create_house_inspection_track_order_for_madina",
  view_export_makkah_house_examination_report: "view_export_makkah_house_examination_report",
  view_export_madina_house_examination_report: "view_export_madina_house_examination_report",
  view_export_departure_campaign_report: "view_export_departure_campaign_report",
  view_export_departure_campaign_report_madina: "view_export_departure_campaign_report_madina",
  view_export_departure_request_report: "view_export_departure_request_report",
  view_export_departure_request_report_madina: "view_export_departure_request_report_madina",
  view_export_departure_group_report: "view_export_departure_group_report",
  view_export_departure_group_report_madina: "view_export_departure_group_report_madina",
}
